import React from "react";
import { ContentAndImage } from "./Components/ContentAndImage";
import { HeaderWithDynamicContent } from "./Components/HeaderWithDynamicContent";
import { BreadCrumbCard } from "./Components/BreadCrumbCard";
import HelmetMetaTag from "./Components/HelmetMetaTag";
import { TempTestPage } from "./TempTestPage";
import ButtonHoverEffect from "./Components/ButtonHoverEffect";
import { ClientComp } from "./Components/ClientComp";
import PersonalizedComp from "./Components/PersonalizedComp";
import Review from "./AboutUs/Review";

export function ReactTechnology() {
  var serviceConent = [];
  serviceConent.push(
    <BreadCrumbCard
      ColSize="col-md-4 py-4"
      Image="./images/Vector.svg"
      CustomHeaderClass="TpPlaceFont clr0E2B3D"
      Header={
        "Mobile App Development for both Android and IOS with an exclusive user interface."
      }
      CustomBodyClass="serviceBodyFonts"
      Body=""
      IsCard="false"
      ImageContainerClass="text-m-center"
    />
  );
  serviceConent.push(
    <BreadCrumbCard
      ColSize="col-md-4 py-4"
      Image="./images/Vector.svg"
      CustomHeaderClass="TpPlaceFont clr0E2B3D"
      Header="UI/UX for all types of applications using the most trending tools and techniques."
      CustomBodyClass="serviceBodyFonts"
      Body=" "
      IsCard="false"
      ImageContainerClass="text-m-center"
    />
  );
  serviceConent.push(
    <BreadCrumbCard
      ColSize="col-md-4 py-4"
      Image="./images/Vector.svg"
      CustomHeaderClass="TpPlaceFont clr0E2B3D"
      Header="Creation of Hybrid Mobile App Development to fulfill various needs of the user."
      CustomBodyClass="serviceBodyFonts"
      Body=""
      IsCard="false"
      ImageContainerClass="text-m-center"
    />
  );
  serviceConent.push(
    <BreadCrumbCard
      ColSize="col-md-4 pt-4 "
      Image="./images/Vector.svg"
      CustomHeaderClass="TpPlaceFont clr0E2B3D"
      Header="App migration services from other platforms without hampering actual experience."
      CustomBodyClass="serviceBodyFonts"
      Body=""
      IsCard="false"
      ImageContainerClass="text-m-center"
    />
  );
  serviceConent.push(
    <BreadCrumbCard
      ColSize="col-md-4 pt-4 "
      Image="./images/Vector.svg"
      CustomHeaderClass="TpPlaceFont clr0E2B3D"
      Header="Web application development for various segments within the prescribed time frame."
      CustomBodyClass="serviceBodyFonts"
      Body=""
      IsCard="false"
      ImageContainerClass="text-m-center"
    />
  );
  serviceConent.push(
    <BreadCrumbCard
      ColSize="col-md-4 pt-4 "
      Image="./images/Vector.svg"
      CustomHeaderClass="TpPlaceFont clr0E2B3D"
      Header="Ecommerce website development for eCommerce companies to showcase their products."
      CustomBodyClass="serviceBodyFonts"
      Body=""
      IsCard="false"
      ImageContainerClass="text-m-center"
    />
  );
  var serviceConent2 = [];
  serviceConent2.push(
    <BreadCrumbCard
      ColSize="col-md-4"
      CustomHeaderClass="pdd-font1"
      Header="User friendly"
      CustomBodyClass=""
      Body="React is regarded as a combination of such remarkable features that make it user-friendly."
      IsCard="false"
    />
  );
  serviceConent2.push(
    <BreadCrumbCard
      ColSize="col-md-4"
      CustomHeaderClass="pdd-font1"
      Header="Virtual DOM"
      CustomBodyClass=""
      Body="An approach used to enhance an application's performance by creating predictable codes."
      IsCard="false"
    />
  );
  serviceConent2.push(
    <BreadCrumbCard
      ColSize="col-md-4"
      CustomHeaderClass="pdd-font1"
      Header="Reusable components"
      CustomBodyClass=""
      Body="The components used in React may indeed be reused in all areas of development."
      IsCard="false"
    />
  );
  serviceConent2.push(
    <BreadCrumbCard
      ColSize="col-md-4"
      CustomHeaderClass="pdd-font1"
      Header="Compatibility"
      CustomBodyClass=""
      Body="React improves efficiency for all versions and many platforms due to compatible features."
      IsCard="false"
    />
  );
  serviceConent2.push(
    <BreadCrumbCard
      ColSize="col-md-4"
      CustomHeaderClass="pdd-font1 text-align-inherit"
      Header="Synchronization with platforms"
      CustomBodyClass=""
      Body="When necessary, it is quite simple to synchronize and respond with another platform."
      IsCard="false"
    />
  );
  serviceConent2.push(
    <BreadCrumbCard
      ColSize="col-md-4"
      CustomHeaderClass="pdd-font1 text-align-inherit"
      Header="Flexibility with plugin tools"
      CustomBodyClass=""
      Body="It also makes it possible for developers to employ third-party plugins without any hassle."
      IsCard="false"
    />
  );

  var techonologiesName = [
    {
      Technology: "Frontend",
    },
    {
      Technology: "Backend",
    },
    {
      Technology: "CMS",
    },
    {
      Technology: "Databases",
    },
    {
      Technology: "Cloud Services",
    },
  ];
  var techonologiesContent = [
    {
      Frontend: [
        {
          Technology: "React.js",
          Img: "/images/Technology/frontendlogo1.png",
        },
        {
          Technology: "Vue.js",
          Img: "/images/Technology/frontendlogo2.png",
        },
        {
          Technology: "Next.js",
          Img: "/images/Technology/frontendlogo3.png",
        },
        {
          Technology: "Angular",
          Img: "/images/Technology/frontendlogo4.png",
        },
        {
          Technology: "Html",
          Img: "/images/Technology/frontendlogo5.png",
        },
        {
          Technology: "Css",
          Img: "/images/Technology/frontendlogo6.png",
        },
        {
          Technology: "Bootstrap",
          Img: "/images/Technology/frontendlogo7.png",
        },
      ],
      Backend: [
        {
          Technology: "Asp.net core",
          Img: "/images/Technology/backendlogo1.png",
        },
        {
          Technology: "Asp.net MVC",
          Img: "/images/Technology/backendlogo2.png",
        },
        {
          Technology: "Node.js",
          Img: "/images/Technology/backendlogo3.png",
        },
        {
          Technology: "Php",
          Img: "/images/Technology/backendlogo4.png",
        },
        {
          Technology: "Laravel",
          Img: "/images/Technology/backendlogo5.png",
        },
        {
          Technology: "Code Igniter",
          Img: "/images/Technology/backendlogo6.png",
        },
      ],
      CMS: [
        {
          Technology: "WooCommerce",
          Img: "/images/Technology/cms1.png",
        },
        {
          Technology: "Shopify",
          Img: "/images/Technology/cms2.png",
        },
        {
          Technology: "Joomla",
          Img: "/images/Technology/cms3.png",
        },
        {
          Technology: "Wix",
          Img: "/images/Technology/cms4.png",
        },
        {
          Technology: "Webflow",
          Img: "/images/Technology/cms5.png",
        },
      ],
      DataBases: [
        {
          Technology: "Sql Server",
          Img: "/images/Technology/database1.png",
        },
        {
          Technology: "MySql Server",
          Img: "/images/Technology/database2.png",
        },
        {
          Technology: "MongoDB",
          Img: "/images/Technology/database3.png",
        },
        {
          Technology: "PostgreSql",
          Img: "/images/Technology/database4.png",
        },
        {
          Technology: "AWS RDS",
          Img: "/images/Technology/database5.png",
        },
      ],
      CloudServices: [
        {
          Technology: "Amazon AWS",
          Img: "/images/Technology/CloudService1.png",
        },
        {
          Technology: "Microsoft Azure",
          Img: "/images/Technology/CloudService2.png",
        },
        {
          Technology: "Google Cloud",
          Img: "/images/Technology/CloudService3.png",
        },
      ],
    },
  ];
  var HeroSection = {
    ImagePosition: "left",
    DescriptionHeader: "Where does it come from?",
    CustomHeaderClass: "C_font1",
    CustomBodyClass: "C_font2",
    Image: "./images/Group.svg",
    CustomImageClass: "",
    CardMargin: "mt-5 px-lg-6 px-sm-6",
    CustomDescriptionBoxClass: "p-lg-4",
    Description:
      "The advent of React.js has expanded the potential for front-end developers to create user-friendly interfaces. React is a fair and truly open front-end JavaScript library for building user interfaces based on UI components. React has now been the fastest-improving program since it was first released as a prototype called 'FaxJS' and then made open-source.",
    customDescriptionItemFirst: "col-lg-5 col-md-5 col-12",
    customDescriptionItemSecond: "col-lg-7 col-md-7 col-12 homePageGYB",
    bodyClassCareerRequirement: "d-none",
  };
  var Overview = {
    Header: "Why do we use it?",
    Content:
      "The main objective of ReactJS is to develop User Interfaces (UI) that increase program speed. It uses virtual DOM (JavaScript object), which improves the effectiveness of the application. The JavaScript virtual DOM is quicker than the default DOM. The approach used by React, which seeks to be both effective and versatile, makes the app more straightforward and handier. The codes become further reliable and easy to troubleshoot when using the declarative view Each element in a React operation is in charge of producing a separate knob of applicable HTML.",
    ContentCustomClass: "pt-4 px-lg-3",
  };
  var OurKey = {
    BgColor: "#F7F7F7",
    Header: "React js Development Services We Offer",
    ContainerBottomPadding: "",
    Content: [serviceConent],
  };
  var PersonalizedCompOne = {
    cardTitle:
      "Looking to migrate your <br/> online identity to a newer <br/> tech or platform?",
    ContainerColor: "FFFPersonalize",
    flag: "1",
  };
  var UiUxProcess = {
    Header: `What attracts you to React?`,
    ContainerBottomPadding: "pb-2",
    ContentCustomClass: "justifyCenter",
    Content: [serviceConent2],

    BgColor: "#F7F7F7",
  };
  var PersonalizedCompTwo = {
    cardTitle:
      "Starting from the Logo to complete <br/> Application design, get in touch!  ",
    ContainerColor: "cA49F9D",
    flag: "2",
  };
  return (
    <>
      <HelmetMetaTag
        titleName="Best web and applications designing team in India - SprigStack"
        title="SprigStack | UI/UX Design Service For Your Web Application."
        desc="Give an attractive look to your application with the help of our UI/UX design that allows you to fascinate your customer for a better ROI."
      />
      <ContentAndImage
        h1Tag={true}
        ImagePosition={HeroSection.ImagePosition}
        DescriptionHeader={HeroSection.DescriptionHeader}
        CustomHeaderClass={HeroSection.CustomHeaderClass}
        CustomBodyClass={HeroSection.CustomBodyClass}
        Image={HeroSection.Image}
        CustomImageClass={HeroSection.CustomImageClass}
        CardMargin={HeroSection.CardMargin}
        CustomDescriptionBoxClass={HeroSection.CustomDescriptionBoxClass}
        Description={HeroSection.Description}
        customDescriptionItemFirst={HeroSection.customDescriptionItemFirst}
        customDescriptionItemSecond={HeroSection.customDescriptionItemSecond}
        bodyClassCareerRequirement={HeroSection.bodyClassCareerRequirement}
      />
      <HeaderWithDynamicContent
        Header={Overview.Header}
        Content={Overview.Content}
        ContentCustomClass={Overview.ContentCustomClass}
      />
      <HeaderWithDynamicContent
        BgColor={OurKey.BgColor}
        Header={OurKey.Header}
        ContainerBottomPadding={OurKey.ContainerBottomPadding}
        Content={OurKey.Content}
      />
      <PersonalizedComp
        cardTitle={PersonalizedCompOne?.cardTitle}
        ContainerColor={PersonalizedCompOne?.ContainerColor}
        flag={PersonalizedCompOne?.flag}
      />
      <HeaderWithDynamicContent
        BgColor={UiUxProcess?.BgColor}
        Header={UiUxProcess?.Header}
        ContainerBottomPadding={UiUxProcess?.ContainerBottomPadding}
        ContentCustomClass={UiUxProcess?.ContentCustomClass}
        Content={UiUxProcess?.Content}
      />
      <div className="row pt-3">
        <div className="col-12 heading">
          Our Full-Cycle React Web Development Method
          <div>
            <img src="/images/hrImg.png" className="image-fluid" />
          </div>
        </div>
        <div className=""></div>
        <div className="method-block-row redesign--technologie-container mx-lg-3 px-lg-6 px-sm-6 pt-3">
          <div className="method-block-col pe-lg-5">
            <div className="method-content">
              <div className="item-header justify-content-m-center text-m-center">
                <h3>
                  <a
                    href="https://keenethics.com/services-business-analysis"
                    className="textcolor"
                  >
                    Analysis of requirements & Project Designing
                  </a>
                </h3>
                <div className="icon-wrapper">
                  <img
                    className="our-methods--content-icon-image-1"
                    src="/images/circle-icon-1.png"
                    alt="Business analysis icon"
                  />
                </div>
              </div>
              <p style={{ textAlign: "justify" }}>
                Knowing clients' thought processes is essential to transform
                their ideas into the greatest results. This will start with a
                good design and framework for the project.
                <br />
              </p>
              <div className="">
                <a href="https://keenethics.com/services-business-analysis">
                  <ButtonHoverEffect />
                </a>
              </div>
            </div>
            <div className="method-content mb-2">
              <div className="item-header justify-content-m-center text-m-center">
                <h3>
                  <a
                    href="https://keenethics.com/services-development-and-quality-assurance"
                    className="textcolor"
                  >
                    Development and testing
                  </a>
                </h3>
                <div className="icon-wrapper">
                  <img
                    className="our-methods--content-icon-image-1"
                    src="/images/circle-icon-1.png"
                    alt=" Development and testing icon"
                  />
                </div>
              </div>
              <p style={{ textAlign: "justify" }}>
                To ensure the smooth operation of the produced project and to
                enjoy a flawless stream of data, We always believe in providing
                quality assured services.
              </p>
              <div className="">
                <a href="https://keenethics.com/services-business-analysis">
                  <ButtonHoverEffect />
                </a>
              </div>
            </div>
          </div>
          <div
            className="method-block-col d-none-for-mobile"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="circle-block">
              <div className="horizontal-line"></div>
              <div className="vertical-line"></div>
              <a
                href="https://keenethics.com/services-business-analysis"
                className="our-methods--content-icon-image-0 our-methods--content-icon-image"
              >
                <img src="/images/Frame.svg" alt="Business analysis icon" />
              </a>
              <a
                href="https://keenethics.com/services-ui-ux-design"
                className="our-methods--content-icon-image-1 our-methods--content-icon-image"
              >
                <img src="/images/Frame.svg" alt="UI/UX design icon" />
              </a>
              <a
                href="https://keenethics.com/services-development-and-quality-assurance"
                className="our-methods--content-icon-image-2 our-methods--content-icon-image"
              >
                <img
                  src="/images/Frame.svg"
                  alt=" Development and testing icon"
                />
              </a>
              <a
                href="https://keenethics.com/services-maintenance-support"
                className="our-methods--content-icon-image-3 our-methods--content-icon-image"
              >
                <img src="/images/Frame.svg" alt="Maintenance icon" />
              </a>
            </div>
          </div>
          <div className="method-block-col pe-lg-5">
            <div className="method-content">
              <div className="item-header justify-content-m-center text-m-center">
                <h3>
                  <a
                    href="https://keenethics.com/services-ui-ux-design"
                    className="textcolor"
                  >
                    UI/UX design & Code development
                  </a>
                </h3>
                <div className="icon-wrapper">
                  <img
                    className="our-methods--content-icon-image-1"
                    src="/images/circle-icon-1.png"
                    alt="UI/UX design icon"
                  />
                </div>
              </div>
              <p style={{ textAlign: "justify" }}>
                We always assure flawless project completion with the help of
                our committed staff who believe in using the latest tools and
                processes for writing code.
              </p>
              <div className="">
                <a href="https://keenethics.com/services-business-analysis">
                  <ButtonHoverEffect />
                </a>
              </div>
            </div>
            <div className="method-content mb-2">
              <div className="item-header justify-content-m-center text-m-center">
                <h3>
                  <a
                    href="https://keenethics.com/services-maintenance-support"
                    className="textcolor"
                  >
                    Maintenance
                  </a>
                </h3>
                <div className="icon-wrapper">
                  <img
                    className="our-methods--content-icon-image-1"
                    src="/images/circle-icon-1.png"
                    alt="Maintenance icon"
                  />
                </div>
              </div>
              <p style={{ textAlign: "justify" }}>
                It is insufficient to simply create and test the project. To
                provide a seamless user experience after deployment, maintenance
                is also necessary whenever required.
              </p>
              <div className="">
                <a href="https://keenethics.com/services-business-analysis">
                  <ButtonHoverEffect />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pb-4">
        <PersonalizedComp
          cardTitle={PersonalizedCompTwo?.cardTitle}
          ContainerColor={PersonalizedCompTwo?.ContainerColor}
          flag={PersonalizedCompTwo?.flag}
        />
        <div className="pt-5" />
        <div className="" style={{ backgroundColor: "#F7F7F7" }}>
          <TempTestPage
            TechName={techonologiesName}
            TechContent={techonologiesContent}
            mainheader="Technologies that we expertise!"
            subHeader="We are expert in various technologies for different needs, take a look below for different categories."
            BgColor="#F7F7F7"
            pt={true}
          />
        </div>
        {/* <ClientComp isBackgroundColor={true} /> */}
        <Review />
      </div>
    </>
  );
}
